function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/Account/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import merge from "lodash.merge";
import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Login, Register } from "../../index";
export var AccountTypes = {
  LOGIN: "login",
  REGISTER: "register"
};
var DefaultLoginConfig = {
  features: {
    registration: true
  }
};
var Account = function Account(_ref) {
  var _components;
  var loginConfig = _ref.loginConfig,
    registerConfig = _ref.registerConfig;
  var _useState = useState(AccountTypes.LOGIN),
    _useState2 = _slicedToArray(_useState, 2),
    accountType = _useState2[0],
    setAccountType = _useState2[1];
  var combinedLoginProps = useMemo(function () {
    return merge(DefaultLoginConfig, loginConfig);
  }, [loginConfig]);
  var components = (_components = {}, _defineProperty(_components, AccountTypes.LOGIN, {
    Component: Login,
    props: combinedLoginProps
  }), _defineProperty(_components, AccountTypes.REGISTER, {
    Component: Register,
    props: registerConfig // Add DefaultRegisterConfig if the need becomes apparent
  }), _components);
  var _components$accountTy = components[accountType],
    Component = _components$accountTy.Component,
    props = _components$accountTy.props;
  return /*#__PURE__*/React.createElement(Component, _extends({
    setAccountType: setAccountType
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 10
    }
  }));
};
Account.propTypes = {
  loginConfig: PropTypes.object.isRequired,
  registerConfig: PropTypes.object.isRequired
};
export default Account;